export default __webpack_public_path__ + "static/ASLA_Helio_3-b2ed319bf570de078c5f8966ec452b9f.png";